import { Label } from '../../ui/label';
import { UploadInput } from '../../UploadInput';

const DocumentsSection = ({ bankForm, updateForm }) => {
  return (
    <div className="p-4 bg-blue-50 rounded-lg border border-blue-200 space-y-4">
      <h3 className="font-semibold text-sm text-blue-800">Opening Documents</h3>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label>Opening Balance Screenshot</Label>
          <UploadInput data-testid="opening-balance-screenshot" className="mt-1"
            onUpload={(data) => updateForm('openingScreenshotDataUrl', data)} />
          {bankForm.openingScreenshotDataUrl && <p className="text-xs text-green-600 mt-1">File uploaded</p>}
        </div>
        <div>
          <Label>Opening Statement</Label>
          <UploadInput data-testid="opening-statement-upload" accept="image/*,.pdf" className="mt-1"
            onUpload={(data) => updateForm('openingStatementDataUrl', data)} />
          {bankForm.openingStatementDataUrl && <p className="text-xs text-green-600 mt-1">File uploaded</p>}
        </div>
      </div>
    </div>
  );
};

export default DocumentsSection;
